import { SectionLayout } from '@/shared/enums';
import BannerLayout from './banner.vue';
import BillboardLayout from './billboard.vue';
import CollectionLayout from './collection.vue';
import DefaultLayout from './default.vue';
import EpgFilterLayout from './epg-filter.vue';
import EpgFullLayout from './epg-full.vue';
import EpgSimpleLayout from './epg-simple.vue';
import HeroLayout from './hero.vue';
import HeroMultipleLayout from './hero-multiple.vue';
import HeroSliderLayout from './hero-slider.vue';
import HeroSimpleLayout from './hero-simple.vue';
import LeaderboardLayout from './leaderboard.vue';
import LiveLayout from './live.vue';
import LogoLayout from './logo.vue';
import OneLineLayout from './one-line.vue';
import OutstreamLayout from './outstream.vue';
import TwoLinesLayout from './two-lines.vue';
import EpisodesLayout from './episodes.vue';

export default {
  [SectionLayout.BANNER]: BannerLayout,
  [SectionLayout.BILLBOARD]: BillboardLayout,
  [SectionLayout.COLLECTION]: CollectionLayout,
  [SectionLayout.DEFAULT]: DefaultLayout,
  [SectionLayout.EPG_FILTER]: EpgFilterLayout,
  [SectionLayout.EPG_FULL]: EpgFullLayout,
  [SectionLayout.EPG_SIMPLE]: EpgSimpleLayout,
  [SectionLayout.HERO]: HeroLayout,
  [SectionLayout.HERO_MULTIPLE]: HeroMultipleLayout,
  [SectionLayout.HERO_SLIDER]: HeroSliderLayout,
  [SectionLayout.HERO_SIMPLE]: HeroSimpleLayout,
  [SectionLayout.LEADERBOARD]: LeaderboardLayout,
  [SectionLayout.OUTSTREAM]: OutstreamLayout,
  [SectionLayout.LIVE]: LiveLayout,
  [SectionLayout.LOGO]: LogoLayout,
  [SectionLayout.ONE_LINE]: OneLineLayout,
  [SectionLayout.TWO_LINE]: TwoLinesLayout,
  [SectionLayout.EPISODES]: EpisodesLayout,
};
